import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import {
  CatalystDrawerOpenProperties,
  EarningsInsightDrawerOpenProperties,
  InsightDrawerOpenProperties,
  InsightIconClickedProperties,
} from './insightsEventTypes';
import { CaptureTrackingEvent, GetEmailTrackingParams } from './types';

export const createInsightsEvents = (
  captureTrackingEvent: CaptureTrackingEvent,
  getEmailTrackingParams: GetEmailTrackingParams
) => {
  const trackInsightsOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.INSIGHTS_OPEN,
      properties: { source },
    });

  const trackInsightsDrawerOpen = ({
    source,
    type,
    insightId,
    entities,
    themeIds,
    ...otherProperties
  }: InsightDrawerOpenProperties) => {
    const emailParams = getEmailTrackingParams();
    const finalSource = emailParams?.source ?? source;
    const finalOtherProperties = emailParams
      ? { ...otherProperties, utm_campaign: emailParams.utm_campaign }
      : otherProperties;

    return captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.INSIGHTS_DRAWER_OPEN,
      properties: {
        ...finalOtherProperties,
        source: finalSource,
        type,
        insightId,
        ...(entities !== undefined && { entities }),
        ...(themeIds !== undefined && { themeIds }),
      },
    });
  };

  const trackEarningsInsightDrawerOpen = ({
    source,
    type,
    insightId,
    entities,
    themeIds,
    ...otherProperties
  }: EarningsInsightDrawerOpenProperties) => {
    const emailParams = getEmailTrackingParams();
    const finalSource = emailParams?.source ?? source;
    const finalOtherProperties = emailParams
      ? { ...otherProperties, utm_campaign: emailParams.utm_campaign }
      : otherProperties;

    return captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.EARNINGS_INSIGHT_DRAWER_OPEN,
      properties: {
        ...finalOtherProperties,
        source: finalSource,
        type,
        insightId,
        ...(entities !== undefined && { entities }),
        ...(themeIds !== undefined && { themeIds }),
      },
    });
  };

  const trackCatalystDrawerOpen = ({
    source,
    type,
    insightId,
    entities,
    themeIds,
    ...otherProperties
  }: CatalystDrawerOpenProperties) => {
    const emailParams = getEmailTrackingParams();
    const finalSource = emailParams?.source ?? source;
    const finalOtherProperties = emailParams
      ? { ...otherProperties, utm_campaign: emailParams.utm_campaign }
      : otherProperties;

    return captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.CATALYST_DRAWER_OPEN,
      properties: {
        ...finalOtherProperties,
        source: finalSource,
        type,
        insightId,
        ...(entities !== undefined && { entities }),
        ...(themeIds !== undefined && { themeIds }),
      },
    });
  };

  const trackInsightIconClicked = ({
    source,
    type,
    insightId,
    entities,
    themeIds,
  }: InsightIconClickedProperties) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.INSIGHT_ICON_CLICKED,
      properties: {
        source,
        type,
        insightId,
        ...(entities !== undefined && { entities }),
        ...(themeIds !== undefined && { themeIds }),
      },
    });

  return {
    trackInsightsOpen,
    trackInsightsDrawerOpen,
    trackEarningsInsightDrawerOpen,
    trackCatalystDrawerOpen,
    trackInsightIconClicked,
  };
};
